"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = exports.handleBgTypeHover = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const framer_motion_1 = require("framer-motion");
const styles_1 = require("../../styles");
const styled_components_2 = require("styled-components");
const handleBgTypeHover = (bgType, theme) => {
    var _a, _b, _c, _d;
    switch (bgType) {
        case 'frozen':
            return (_a = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _a === void 0 ? void 0 : _a.dark_frozen;
        case 'red':
            return (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.creme;
        case 'white':
            return (_c = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _c === void 0 ? void 0 : _c.creme;
        default:
            return (_d = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _d === void 0 ? void 0 : _d.red;
    }
};
exports.handleBgTypeHover = handleBgTypeHover;
exports.Button = (0, react_1.memo)(({ bgType = 'darkcreme', children, circle = false, disabled = false, className = '', id, name = 'Button', onClick = null, outline = false, type = 'button', uppercase = false, noHoverEffect = false, initial, variants, exit, animate, custom }) => {
    return ((0, jsx_runtime_1.jsxs)(ButtonStyled, Object.assign({}, (id && { id }), { className: className, onClick: onClick, type: type, "$bgType": bgType, "$circle": circle, disabled: disabled, "$uppercase": uppercase, name: name, "$outline": outline, "$noHoverEffect": noHoverEffect }, (initial && { initial }), (variants && { variants }), (exit && { exit }), (animate && { animate }), (custom && { custom }), { children: [(0, jsx_runtime_1.jsx)("div", { className: 'button__bg' }), (0, jsx_runtime_1.jsx)("div", { children: children })] })));
});
const ButtonStyled = (0, styled_components_1.default)(framer_motion_1.motion.button) `
  ${(0, styles_1.getP15)()}
  align-items: center;
  background-color: ${({ $bgType, theme, $outline }) => $outline ? 'transparent' : theme.colors[$bgType]};
  color: ${({ theme, $bgType, $outline }) => { var _a; return $outline ? theme.colors[$bgType] : (_a = theme.colors) === null || _a === void 0 ? void 0 : _a[$bgType === 'background' ? 'darkred' : $bgType === 'creme' || $bgType === 'white' ? 'red' : 'white']; }};
  display: flex;
  font-family: ${({ theme }) => theme.fonts.secondaryFont};
  justify-content: center;
  letter-spacing: 0;
  margin: 0 auto;
  position: relative;
  text-transform: ${({ $uppercase }) => $uppercase ? 'uppercase' : 'initial'};

  ${styles_1.mq.greaterThan('tablet')} {
    ${(0, styles_1.getP18_1B)()}
  }

  ${({ $circle }) => $circle ? (0, styled_components_2.css) `
    height: ${(0, styles_1.vw)(38, 'mobile')};
    padding: 0 ;
    width: ${(0, styles_1.vw)(38, 'mobile')};

    ${styles_1.mq.greaterThan('nexus7')} {
      height: ${(0, styles_1.vw)(38, 'nexus7')} ;
      width: ${(0, styles_1.vw)(38, 'nexus7')};
    }

    ${styles_1.mq.greaterThan('tablet')} {
      height:${(0, styles_1.vw)(40, 'desktop')};
      width:${(0, styles_1.vw)(40, 'desktop')};
    }

    ${styles_1.mq.greaterThan('desktop')} {
      height: 40px;
      width: 40px;
    }
    ` : (0, styled_components_2.css) `
    height:${(0, styles_1.vw)(50, 'mobile')};
    padding:${(0, styles_1.vw)(17, 'mobile')} ${(0, styles_1.vw)(30, 'mobile')};
    width:unset;

    ${styles_1.mq.greaterThan('nexus7')} {
      height: ${(0, styles_1.vw)(50, 'nexus7')};
      padding:${(0, styles_1.vw)(17, 'nexus7')} ${(0, styles_1.vw)(30, 'nexus7')};
    }

    ${styles_1.mq.greaterThan('tablet')} {
      height:${(0, styles_1.vw)(60, 'desktop')};
      padding: ${(0, styles_1.vw)(19, 'desktop')} ${(0, styles_1.vw)(43, 'desktop')};
    }

    ${styles_1.mq.greaterThan('desktop')} {
      height:60px;
      padding: 19px 43px;
    }
  `}



  &[type='submit'] {
    ${(0, styles_1.getP15)()}
  }

  &,
  &:before {
    transition: 300ms background-color ${({ ease }) => ease}, 300ms border ${({ ease }) => ease}, 300ms color ${({ ease }) => ease}, 300ms filter ${({ ease }) => ease}, 300ms opacity ${({ ease }) => ease};

    ${({ $circle }) => $circle ? (0, styled_components_2.css) `
      border-radius: 50%;
    
      ` : (0, styled_components_2.css) `
      border-radius:${(0, styles_1.vw)(30, 'mobile')};


      ${styles_1.mq.greaterThan('nexus7')} {
        border-radius:${(0, styles_1.vw)(30, 'nexus7')};
      }

      ${styles_1.mq.greaterThan('tablet')} {
        border-radius:${(0, styles_1.vw)(30, 'desktop')};
      }
      
      ${styles_1.mq.greaterThan('desktop')} {
        border-radius: 30px;
      }
    `}
  }

  &[disabled] {
    cursor: not-allowed;
    opacity: .4;
    pointer-events: none;

    &:before {
      content: none;
      display: none;
    }
  }


  > div:last-of-type {
    ${(0, styles_1.getP15)()}
    align-items: center;
    color: inherit;
    display: flex;
    height: 100%;
    justify-content: center;
    font-family: ${({ theme }) => theme.fonts.secondaryFont};
    width: 100%;
    z-index: 2;
    transition: transform 0.4s cubic-bezier(0.1, 0, 0.3, 1);
    white-space: nowrap;

    img {
      padding: ${(0, styles_1.vw)(10, 'mobile')};

      ${styles_1.mq.greaterThan('nexus7')} {
        padding: ${(0, styles_1.vw)(10, 'nexus7')};
      }

      ${styles_1.mq.greaterThan('tablet')} {
        padding: ${(0, styles_1.vw)(10, 'desktop')};
      }

      ${styles_1.mq.greaterThan('desktop')} {
        padding: 10px;
      }
    }
  }

  .button__bg {
    top: 0;
    left: 0;
    position: absolute;
    width: 100%;
    height: 100%;
    overflow: hidden;
    transition: transform 0.4s cubic-bezier(0.1, 0, 0.3, 1);
    background: ${({ $bgType, theme, $outline }) => $outline ? 'transparent' : theme.colors[$bgType]};
    border: ${({ $bgType, theme, $outline }) => $outline ? `1px solid ${theme.colors[$bgType]}` : 'none'};
   
    ${({ $circle }) => $circle ? (0, styled_components_2.css) `
      border-radius: 50%;
    ` : (0, styled_components_2.css) `
      border-radius:${(0, styles_1.vw)(30, 'mobile')};

      ${styles_1.mq.greaterThan('nexus7')} {
        border-radius:${(0, styles_1.vw)(30, 'nexus7')};
      }

      ${styles_1.mq.greaterThan('tablet')} {
        border-radius:${(0, styles_1.vw)(30, 'desktop')};
      }
      
      ${styles_1.mq.greaterThan('desktop')} {
        border-radius: 30px;
      }
    `}

    &:before,
    &:after {
      content: '';
      position: absolute;
      z-index: -1;
      background-color: ${({ $bgType, theme, $circle, $outline }) => $circle || $outline ? 'transparent' : (0, exports.handleBgTypeHover)($bgType, theme)};
    }

    &:before {
      width: 110%;
      height: 0;
      padding-bottom: 110%;
      top: 50%;
      left: 50%;
      border-radius: 50%;
      transform: translate3d(-50%,-50%,0) scale3d(0,0,1);
    }

    &:after {
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      transition: opacity 0.3s;
    }
  }

  &:hover {
    color: ${({ theme, $outline, $bgType }) => $outline ? theme.colors[$bgType] : theme.colors.white};

    .button__bg {
      transform: 'none';

      ${styles_1.mq.greaterThan('tablet')} {
        transform: ${({ $circle, $noHoverEffect }) => $noHoverEffect ? 'none' : $circle ? 'scale3d(1.2,1.2,1)' : 'scale3d(1.1,1.2,1)'};
      }

      &:before {
        transition: transform 0.4s cubic-bezier(0.1, 0, 0.3, 1);
        transform: translate3d(-50%,-50%,0) scale3d(1,1,1);
      }

      &:after {
        opacity: 1;
        transition-duration: 0.01s;
        transition-delay: 0.3s;
      }
    }
  }
`;
